import { Field } from '@nestjs/graphql'
import { BaseUpdateDto } from '../base/baseUpdate.dto'
import { ArgsType } from '@nestjs/graphql'

@ArgsType()
export class UpdatePenNameDto extends BaseUpdateDto<UpdatePenNameDto> {
  @Field(type => String, { nullable: true })
  name?: string

  @Field({ nullable: true })
  bio?: string

  @Field({ nullable: true })
  image?: string

  @Field({ nullable: true })
  facebookLink?: string

  @Field({ nullable: true })
  bookbubLink?: string

  @Field({ nullable: true })
  twitterLink?: string

  @Field({ nullable: true })
  instagramLink?: string

  @Field({ nullable: true })
  websiteLink?: string

  @Field({ nullable: true })
  newsletterLink?: string

  @Field({ nullable: true })
  tiktokLink?: string

  @Field({ nullable: true })
  amazonLink?: string

  @Field({ nullable: true })
  goodreadsLink?: string
}
